import styled, { css } from "styled-components";
import { Modal, Select, Button } from "antd";
import DatatableAntd from "components/datatable-antd";

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Title = styled.h2`
  margin-bottom: 8px;
  font-weight: bold;
  font-size: 15px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ModalContentWrap = styled.div`
  height: 140px;
  flex-shrink: 0;
`;

export const ModalTableContentWrap = styled.div`
  display: flex;
  flex-direction: column;
  /* height: 100%; */
  flex: 1;
  min-height: 0;
`;

export const CustomModal = styled(Modal)`
  position: relative;
  /* height: 90%; */
  /* max-height: 90vh; */
  max-height: 90vh;

  .ant-modal-content {
    border-radius: 10px;
    height: 100%;
    
    display: flex;
    flex-direction: column;
  }

  .ant-modal-header {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: #12619C;
    height: 61px;
  }

  .ant-modal-title {
    color: #fff;
    font-weight: bold;
  }

  .ant-modal-close-x {
    color: #fff;
  }

  .ant-form-item-required::before {
      content: none !important;
    }

  .ant-form-item-required::after {
    display: inline-block !important;
    margin-left: 4px !important;
    color: red;
    font-size: 14px !important;
    line-height: 1 !important;
    content: "*" !important;
  }

  td .ant-form-item {
    margin-bottom: 0;
  }

  td .ant-form-item-with-help .ant-form-item-explain {
    display: none;
  }

  td input[type=number], td input[type=date] {
    height: 2.4rem;
  }

  .ant-modal-body {
    padding: 0;
    position: relative;

    max-height: calc(90vh - 122px);
    height: auto;
    display: flex;
    flex-direction: column;
    flex: 0 0 auto;

    overflow: hidden;
  }

  .ant-modal-footer {
    height: 61px;
  }

  .inner-overlay {
    position: absolute;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.45);
    z-index: 5;
    backdrop-filter: blur(2px);
  }
`;

export const RoundedTable = styled(DatatableAntd)`
  .ant-table {
    border-radius: 8px;
    overflow: hidden;
  }

  .ant-table-container {
    border-radius: 8px;
    overflow: hidden;
  }

  .show {
    display: block !important;
  }

  .hidden {
    display: none !important;
  }

  .ant-input-number {
    width: 66px;
  }

`;

export const ButtonAddItem = styled.button`
    padding: 10px 16px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    transition: all 0.2s ease;
    flex: 0 0 auto;
    width: auto;
    align-self: flex-start;

    background: #12619C;
    color: #fff;
    border: 1px solid #e0e0e0;

    :disabled {
        cursor: not-allowed;
        color: rgba(0, 0, 0, 0.25);
        border-color: #d9d9d9;
        background: #f5f5f5;
    }

`;

export const ContainerTable = styled.div<{ isOverflow: boolean }>`
  flex: 1;
  min-height: 0; 

  padding-bottom: 25px;

  > div > div > div > div > div,
  > div > div > div > div > div > div,
  .ant-table-cell:has(input) {
    overflow: visible !important;
  }

  .css-0, 
  .ant-table-wrapper, 
  .ant-spin-nested-loading, 
  .ant-spin-container, 
  .ant-table, 
  .ant-table-container {
    height: 100%;
  }

  position: relative;
  width: 100%;

  .ant-table {
    table-layout: fixed !important;
  }

  .ant-table-container {
    overflow: visible !important;
  }


.ant-table-thead > tr > th,
.ant-table-tbody > tr > td {
  white-space: nowrap;
}

  .ant-select {
    cursor: text;
    min-width: 100px;
    border-radius: 0.375rem;
  }
  .ant-select-selector {
    height: 2.4rem;
  }
`;

export const VinculoLink = styled.div<{ disabled: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 12px;
  background: #E3F2FD;
  border: 1px solid #2196F3;
  border-radius: 16px;
  font-size: 11px;
  font-weight: 500;
  color: #1976D2;
  cursor: pointer;
  transition: all 0.2s ease;

  ${props => props.disabled && css`
    pointer-events: none;
    opacity: 0.5;
  `}
`;

export const SelectAntd = styled(Select)`
  .ant-select-selector {
    height: 40px !important;
    border-radius: 8px !important;
    padding: 4px 11px !important;
  }

  &.ant-select-multiple > .ant-select-selector {
    border: 1px solid #d9d9d9 !important;
     box-shadow: none !important;
     outline: none !important;
  }
  &.ant-select-multiple > .ant-select-selector:hover {
    border: 1px solid #40a9ff !important;
     box-shadow: none !important;
     outline: none !important;
  }
  &.ant-select-multiple.ant-select-open > .ant-select-selector {
    border-color: #40a9ff !important;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2) !important;
    border-right-width: 1px !important;
    outline: 0;
  }

`;

export const SelectAntdStyled = styled(Select)`
  .ant-select-selector {
    height: 2.5rem !important;
    border-radius: 0.375rem !important;
    padding: 4px 12px !important;
  }

    &.ant-select-multiple > .ant-select-selector {
    border: 1px solid #d9d9d9 !important;
     box-shadow: none !important;
     outline: none !important;
  }
  &.ant-select-multiple > .ant-select-selector:hover {
    border: 1px solid #40a9ff !important;
     box-shadow: none !important;
     outline: none !important;
  }
  &.ant-select-multiple.ant-select-open > .ant-select-selector {
    border-color: #40a9ff !important;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2) !important;
    border-right-width: 1px !important;
    outline: 0;
  }
  
  .ant-select-item .ant-select-item-option {
    font-size: 0.75rem;
  }
  
`;

export const ModalContainer = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;

  flex: 1;
  min-height: 0;
  height: 100%;
`;

export const ButtonStyled = styled(Button)`
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  float: right;
  background-color: #11a557;
  border: none;

  &:hover, &:active, &:focus {
    background-color: #0e8a47;
  }
`

export const ContentFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ContentMdDelete = styled.div<{ disabled: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;

  opacity: ${props => props.disabled ? 0.5 : 1};

  ${props => props.disabled && css`
    pointer-events: none;
    cursor: not-allowed;
  `}
;
`

export const MessageWarning = styled.div`
  font-weight: 700;
  color: red;
`;